/**
 * @generated SignedSource<<f8f69d8a5ea79906151984291731e47d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupImportContainerMetadataQuery$variables = {
  siteSlug: string;
};
export type PopupImportContainerMetadataQueryVariables = PopupImportContainerMetadataQuery$variables;
export type PopupImportContainerMetadataQuery$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly slug: string;
      } | null;
    } | null> | null;
  };
  readonly site: {
    readonly id: string;
    readonly owner: {
      readonly schedules: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly startTime: string | null;
            readonly endTime: string | null;
          } | null;
        } | null> | null;
      };
    };
  };
};
export type PopupImportContainerMetadataQueryResponse = PopupImportContainerMetadataQuery$data;
export type PopupImportContainerMetadataQuery = {
  variables: PopupImportContainerMetadataQueryVariables;
  response: PopupImportContainerMetadataQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 500
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    (v1/*: any*/)
  ],
  "concreteType": "SourceConnection",
  "kind": "LinkedField",
  "name": "sources",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SourceEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Source",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sources(first:500)"
},
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "siteSlug"
  }
],
v5 = {
  "alias": null,
  "args": [
    (v1/*: any*/),
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": {
        "direction": "ASC",
        "field": "START_TIME"
      }
    }
  ],
  "concreteType": "ScheduleConnection",
  "kind": "LinkedField",
  "name": "schedules",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScheduleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Schedule",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "schedules(first:500,orderBy:{\"direction\":\"ASC\",\"field\":\"START_TIME\"})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupImportContainerMetadataQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupImportContainerMetadataQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "58eae03065dc245a6375381a2c0c5e9a",
    "id": null,
    "metadata": {},
    "name": "PopupImportContainerMetadataQuery",
    "operationKind": "query",
    "text": "query PopupImportContainerMetadataQuery(\n  $siteSlug: String!\n) {\n  sources(first: 500) {\n    edges {\n      node {\n        id\n        name\n        slug\n      }\n    }\n  }\n  site(slug: $siteSlug) {\n    id\n    owner {\n      schedules(first: 500, orderBy: {field: START_TIME, direction: ASC}) {\n        edges {\n          node {\n            id\n            startTime\n            endTime\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2fa8972d25df14932767d2d8d7f3fb6";

export default node;
